import { render, staticRenderFns } from "./createDialog.vue?vue&type=template&id=561db530"
import script from "./createDialog.vue?vue&type=script&lang=js"
export * from "./createDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports